// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2315":"1f5fe265","6436":"bc4f06fb"}[chunkId] + ".chunk.css";
};